import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import TierSidebarCard from '../../../../DeviationViews/TierSidebarCard';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { getTierListCardBI } from '../../../helpers';
import SubscriptionLockFTUE from '../../../../Tier/ftue/SubscriptionLockFTUE';
import { useSubscriptionLockSidebarFTUE } from '../../../../Tier/ftue/useSubscriptionLockFTUE';
import s from './TierList.scss';
var TierList = function (_a) {
    var _b, _c;
    var block = _a.block, parentDeviation = _a.deviation;
    var _d = useSubscriptionLockSidebarFTUE(block.contentType, parentDeviation), isShowingSubscriptionsFTUE = _d.isShowingSubscriptionsFTUE, dropFlag = _d.dropFlag;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block, className: s[block.contentType], headerClassName: s['header'], titleClassName: s['title'], seeAllClassName: s['link'] },
        React.createElement(DeviationDuperbrowseContext, { streamId: "sidebar-tiers-" + block.contentType, deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parent: {
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId,
            } }, (_c = block.deviations) === null || _c === void 0 ? void 0 : _c.map(function (tier, i) {
            return isShowingSubscriptionsFTUE && i === 0 ? (React.createElement(SubscriptionLockFTUE, { dropFlag: dropFlag, className: s['ftue'], key: tier.deviationId, deviation: tier })) : (React.createElement(TierSidebarCard, { key: tier.deviationId, biData: getTierListCardBI(block.contentType, tier), className: s['tier'], deviation: tier }));
        }))));
};
TierList.displayName = 'TierList';
export default TierList;
//# sourceMappingURL=TierList.js.map